import { NgClass } from '@angular/common';
import {
  ChangeDetectionStrategy,
  ChangeDetectorRef,
  Component,
  DestroyRef,
  HostBinding,
  Input,
  OnInit,
} from '@angular/core';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import { PaletteType, ResponsiveService, SizeType, WeightType } from '@cf/core';
import { skipWhile } from 'rxjs';

@Component({
  // eslint-disable-next-line @angular-eslint/component-selector
  selector: 'a[cf-link]',
  templateUrl: './link.component.html',
  styleUrls: ['./link.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [NgClass],
})
export class LinkComponent implements OnInit {
  @Input() className: string | null = null;

  @Input() size: SizeType = 'md';

  @Input() touchSize!: SizeType;

  @Input() underlined = false;

  @Input() bordered = false;

  @Input() disabled = false;

  @Input() overflow = true;

  @Input() color: PaletteType = 'blue-50';

  @Input() weight: WeightType = '500';

  @Input() maxLineClamp!: string;

  // eslint-disable-next-line no-untranslated-string/no-untranslated-string
  @HostBinding('class') classes = 'cf-link';

  @HostBinding('style.pointer-events') get pEvents(): string {
    if (this.disabled) {
      return 'none';
    }
    return 'auto';
  }

  constructor(
    private readonly responsiveService: ResponsiveService,
    private readonly cd: ChangeDetectorRef,
    private readonly destroyRef: DestroyRef,
  ) {}

  get classNames(): string {
    if (this.color) {
      return `${this.classes} ${this.classes}--${this.color}`;
    }
    return this.classes;
  }

  ngOnInit() {
    const initialSize = this.size;

    this.responsiveService.isTouch$
      .pipe(
        skipWhile(() => this.touchSize === initialSize || !this.touchSize),
        takeUntilDestroyed(this.destroyRef),
      )
      .subscribe((isTouchScreen) => {
        if (isTouchScreen) {
          this.size = this.touchSize;
        } else {
          this.size = initialSize;
        }

        this.cd.detectChanges();
      });
  }
}
